import { useState, useEffect } from "react";
import React from "react";
import { LOGO_DATA_URL } from "../data/mockData";
export default function LoginScreen({ onLogin }) {

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const login = async () => {
    const response = await fetch("https://zpteacherawards.in/api/auth/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username,
        password,
      }),
    });

    if (!response.ok) {
      alert("Invalid username or password");
      return;
    }

    const data = await response.json();

    localStorage.setItem("token", data.token);
    localStorage.setItem ("userId", data.userId);
    localStorage.setItem ("role", data.role);

    onLogin();
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-3 sm:p-6"
      style={{
        background:
          "radial-gradient(circle at 20% 15%, #123354 0%, #0a1e33 55%, #081522 100%)",
      }}
    >
      <div className="bg-white w-full max-w-md rounded-2xl overflow-hidden shadow-2xl">
        <div
          className="relative text-center px-4 sm:px-8 pt-6 sm:pt-8 pb-5 sm:pb-6 text-white"
          style={{ background: "linear-gradient(135deg,#0e2a47,#1f4d78)" }}
        >
          <div className="w-14 h-14 mx-auto mb-3 rounded-full border-2 border-amber-400 overflow-hidden bg-white/5">
            <img
              src={LOGO_DATA_URL}
              alt="सातारा जिल्हा परिषद लोगो"
              className="w-full h-full object-cover"
            />
          </div>
          <h1 className="text-xl mb-1" style={{ fontFamily: "serif" }}>
            सातारा जिल्हा परिषद, सातारा
          </h1>
          <p className="text-sm opacity-80">
            शिक्षण विभाग · शिक्षक पुरस्कार गुणांकन तक्ता — सन २०२६-२०२७
          </p>
          <div
            className="absolute left-0 right-0 bottom-0 h-1"
            style={{
              background: "linear-gradient(90deg,#dc9a34,#f0c268,#dc9a34)",
            }}
          />
        </div>
        <div className="px-4 sm:px-8 pt-6 sm:pt-7 pb-6 sm:pb-8">
          <label className="block text-sm font-semibold text-slate-500 mb-1.5">
            वापरकर्ता आयडी
          </label>
          <input
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <label className="block text-sm font-semibold text-slate-500 mb-1.5">
            पासवर्ड
          </label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button
            onClick={login}
            className="w-full bg-slate-900 hover:bg-slate-800 text-white font-semibold py-3 rounded-lg"
          >
            प्रवेश करा
          </button>
          <p className="text-center text-xs text-slate-400 mt-4">
            हे एक कार्यरत नमुना (prototype) आहे — प्रात्यक्षिक माहितीसह.
            वास्तविक प्रमाणीकरण जोडलेले नाही.
          </p>
        </div>
      </div>
    </div>
  );
}
